export const getVouchersFromRedemption = (redemption) => {
  const codes = []
  redemption.order.products.forEach((product) => {
    product.items.forEach((item) => {
      item.product = {
        uuid: product.uuid,
        name: product.name
      }
      item.deal = redemption.deal
      codes.push(item)
    })
  })

  return codes
}
